import React from 'react'
import {Modal,Button } from 'react-bootstrap';

const Loading = (props) => (
  
    <div class="">
        <div class={props.themeSet==='d'?"loader_man loader_dark":"loader_man"}>
            {/* <div class="loader">
            </div> */}
            <Modal
                    show={true}
                    dialogClassName="modal-90w mx400"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    
                    <Modal.Body>
                   
               
                        <div className="form-group text-center p-2 pt-md-4 pb-md-4">
						<h3>Alert</h3>
                        <h5 className="mt-3 mb-4">We are upgrading Play to Earn Games for a better user experience. The upgradation would happen tomorrow 21/12/2022  till 13:00 (GMT +5:30)<br/>We look forward to seeing you soon!!</h5>
                             <Button className="btn_man"  variant="secondary" >Close</Button>
                        </div> 
                    </Modal.Body>

                  
                </Modal>
        </div>
    </div>
)

export default Loading;

